import PropTypes from 'prop-types';
import React from 'react';

/*
 * Crypto Currencies
 */
import { ReactComponent as Btc } from '../../assets/coins/btc.svg';
import { ReactComponent as Eth } from '../../assets/coins/eth.svg';
import { ReactComponent as Eur } from '../../assets/coins/eur.svg';
/*
 * Fiat Currencies
 */
import { ReactComponent as Gbp } from '../../assets/coins/gbp.svg';
import { ReactComponent as Ltc } from '../../assets/coins/ltc.svg';
import { ReactComponent as Ngn } from '../../assets/coins/ngn.svg';
import { ReactComponent as Qdx } from '../../assets/coins/qdx.svg';
import { ReactComponent as Usd } from '../../assets/coins/usd.svg';
import { ReactComponent as Usdt } from '../../assets/coins/usdt.svg';
import { ReactComponent as Xrp } from '../../assets/coins/xrp.svg';

const Coin = ({ slug, icon_url, ...props }) => {
  const coinImage = <img className="coin__icon" src={icon_url} {...props} alt={slug} />;
  const CoinSvg = coins[slug.toLowerCase()] ?? 'span';

  return icon_url ? coinImage : <CoinSvg className="coin__icon" {...props} />;
};

const coins = {
  eur: Eur,
  gbp: Gbp,
  ngn: Ngn,
  usd: Usd,
  usdt: Usdt,
  btc: Btc,
  eth: Eth,
  ltc: Ltc,
  qdx: Qdx,
  xrp: Xrp
};

Coin.propTypes = {
  slug: PropTypes.string,
  icon_url: PropTypes.string
};

export { Coin };
